import { Box, Menu, Typography } from '@mui/material'
import React, { useState } from 'react'
import IconTooltipButton from '../../../../../button/IconTooltipButton'
import ListMenu from '../../../../../commom/ListMenu'
import { useParams } from 'react-router-dom'
import DialogElement from '../Dialog/Dialog'
import { setParentData } from '../../utils'

const ItemList = ({ item, onSettingChildren, parent }) => {
  return (
    <div className='flex flex-col w-full'>
      <div
        className='px-4 py-4 flex items-center justify-start relative min-w-150px relative'
        style={{
          backgroundColor: item?.primaryColor ?? 'initial',
          color: item?.secondaryColor ?? 'initial',
          border: `1px solid var(--background)`,
        }}
      >
        <Typography>
          {item.name} 
        </Typography>
        <IconTooltipButton
          title='Setting'
          icon={["far", "ellipsis-vertical"]}
          className=''
          style={{
            borderRadius: '0.5rem',
            backgroundColor: 'var(--background)',
            color: 'var(--primary)',
            padding: '0.45rem 0.4rem',
            position: 'absolute',
            top: '0.5rem',
            right: '0.5rem',
            width: '1.5rem',
            height: '1.5rem'
          }}
          onClick={(e) => onSettingChildren(e, {
            item,
            parent,
            childrenId: item._id
          })}
        />
      </div>
      { item?.children?.length > 0 && 
        <div className='flex pl-2'>
          { item.children.map((child) => (
            <ItemList 
              item={child} 
              key={child._id}
              childrenId={item._id}
              parent={setParentData({ _id: item._id, name: item.name }, parent)}
              onSettingChildren={onSettingChildren}
            />
          )) }
        </div>
      }
    </div>
  )

}

const initialState = {
  mouseX: null, mouseY: null 
}

const List = ({ data }) => {
  const { curriculumId } = useParams()
  const [menuChildren, setMenuChildren] = useState(initialState);
  const [modal, setModal] = useState(null)
  const [dataModal, setDataModal] = useState(null)

  const handleMenuChildrenClose = () => setMenuChildren(initialState)
  const handleMenuChildrenOpen = (event, data) => {
    setMenuChildren({
      mouseX: event.clientX - 2,
      mouseY: event.clientY - 4
    });
    setDataModal(data)
  };

  return (
    <Box className='absolute inset-x-0'>
      <Box className='px-4 overflow-auto'>
        <ItemList 
          item={data}
          onSettingChildren={handleMenuChildrenOpen}
        />
      </Box>
      { menuChildren &&
        <Menu
          id={`menuChildren-${curriculumId}`}
          MenuListProps={{
            style: { width: '260px' },
            className: "list-menuChildren p-0"
          }}
          keepMounted
          open={menuChildren.mouseY !== null}
          onClose={handleMenuChildrenClose}
          anchorReference="anchorPosition"
          anchorPosition={
            menuChildren.mouseY !== null && menuChildren.mouseX !== null
              ? { top: menuChildren.mouseY, left: menuChildren.mouseX }
              : undefined
          }
        >
          <ListMenu
            id={`menuChildren-list-${curriculumId}`}
            items={[
                { 
                  label: 'Edit',
                  icon: 'pencil',
                  permissions: true,
                  onClick: () => {
                    setModal({ 
                      type: 'edit',
                      data: dataModal
                    })
                  }
                },
                { 
                  label: 'Delete',
                  icon: 'trash-alt',
                  permissions: !!dataModal?.parent,
                  onClick: () => {
                    setModal({ 
                      type: 'delete',
                      data: {
                        parent: dataModal?.parent,
                        childrenId: dataModal?.childrenId,
                        item: dataModal?.item
                      }
                    })
                  }
                },
                { 
                  divider: true,
                  label: 'Add children',
                  icon: 'plus',
                  permissions: true,
                  onClick: () => {
                    setModal({ 
                      type: 'add',
                      data: {
                        parent: dataModal?.parent,
                        childrenId: dataModal?.childrenId,
                        item: {}
                      }
                    })
                  }
                }
              ]
              .filter((item) => item.permissions)
              .map((item) => ({ 
                ...item, 
                onClick: () => {
                  if (item.onClick) {
                    item.onClick()
                  }
                  handleMenuChildrenClose()
                }
              }))
            } 
          />
        </Menu>   
      }
      { modal &&
        <DialogElement
          show={!!modal}
          type={modal.type}
          onClose={() => setModal(null)}
          data={modal.data}
          setChange={(old) => !old}
        />
      }
    </Box>
  )
}

export default List